import Lottie from 'lottie-react';


const Placeholder = ({ animationData, height = 0, title = '', message = '' }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-6 px-4">
       <Lottie animationData={animationData} loop={true} style={{ height: height || '150px' }} />
      <p className="text-coalBlack headingText capitalize !mt-5">{title}</p>
      <p className="text-[12px] text-navLink mt-2 max-w-md">{message}</p>
    </div>
  );
};

export default Placeholder;
